import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const rotationMap = {
  right: '-45deg',
  left: '135deg',
  up: '-135deg',
  down: '45deg',
}

const themes = {
  light: 'rgb(178, 186, 189)',
  white: '#FFF',
}

const Icon = styled.i`
    border: solid ${props => themes[props.theme] || '#384047'};
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(${props => rotationMap[props.direction]});
    height: 0;
    width: 0;
`

function Caret (props) {
  const { direction, theme } = props
  return (
    <Icon direction={direction} theme={theme} />
  )
}

Caret.propTypes = {
  direction: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'white']),
}
export default Caret



// WEBPACK FOOTER //
// ./src/images/icons/Caret.js